module.exports = __webpack_public_path__ + "static/media/Klok.86105678.mp3";